import { JobChangeStatusInterface } from '../../../interfaces/job-change-status.interface';

export class ClearAwaitingJobStatus {
    public static readonly type = '[JobsPlacements] Clear job awaiting status';

    constructor(public data: JobChangeStatusInterface) {}
}
